import { Archive, Flame, LayoutGrid, MessagesSquare, RefreshCw, Search, type LucideIcon } from 'lucide-react';

export interface HiveModule {
  id: string;
  name: string;
  path: string;
  /** What it does, in a few words. */
  summary: string;
  /** The build phase that brings it to life (docs/phases/). */
  phase: number;
  icon: LucideIcon;
}

/** The six modules, in sidebar order. Names are fixed (see CLAUDE.md). */
export const MODULES: readonly HiveModule[] = [
  { id: 'forge', name: 'Forge', path: '/forge', summary: 'Ideas and design docs', phase: 2, icon: Flame },
  {
    id: 'grid',
    name: 'Grid',
    path: '/grid',
    summary: 'Tasks in list, kanban and Gantt views',
    phase: 1,
    icon: LayoutGrid,
  },
  {
    id: 'cycles',
    name: 'Cycles',
    path: '/cycles',
    summary: 'Sprints, burndown and reviews',
    phase: 4,
    icon: RefreshCw,
  },
  { id: 'comms', name: 'Comms', path: '/comms', summary: 'Studio and game chat', phase: 5, icon: MessagesSquare },
  { id: 'vault', name: 'Vault', path: '/vault', summary: 'Drive and Figma links, uploads', phase: 3, icon: Archive },
  { id: 'scan', name: 'Scan', path: '/scan', summary: 'One search across everything', phase: 3, icon: Search },
];
